import { Component, OnInit, Inject, EventEmitter, Output } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA,MatDialog} from '@angular/material/dialog';

@Component({
  selector: 'confirm-modal',
  templateUrl: './confirm-modal.component.html',
  styleUrls: ['./confirm-modal.component.scss']
})
export class ConfirmModalComponent implements OnInit {

  public static OK :string = 'OK';
  public static NOK :string = 'NOK';

  constructor(
    public dialogRef: MatDialogRef<ConfirmModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) {
  }

  NokClick(): void {
    this.dialogRef.close(ConfirmModalComponent.NOK);
  }

  OkClick(): void {
    this.dialogRef.close(ConfirmModalComponent.OK);
  }

  ngOnInit() {
  }

}